export const AdminEmploymentProfileRoutes = [
    {
        "url": "/employment-profile?brand_id&conversation_id&conversation_group_id",
        "name": "appLayout.harriSH.employmentProfile",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'adminEmploymentProfile',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["communication_hub_shared"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/admin-employment-profile/admin-employment-profile.downgrade.module");
                }
            },
            { type: "library", path: `${CDNUri || '../'}ext_libs/jwplayer/jwplayer.js` },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/communication-hub/communication-hub.shared.downgrade.module");
                }
            },
        ]
    }, {
        "url": "/tl-employment-profile",
        "name": "appLayout.schedule.employmentProfile",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "views": {
            "body": {
                "component": "adminEmploymentProfile"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/admin-employment-profile/admin-employment-profile.downgrade.module");
                }
            },
        ]
    }
];
//# sourceMappingURL=admin-employment-profile.routes.js.map